import React, { useState } from 'react';
import { Link, Redirect } from 'react-router-dom';

import { connect } from 'react-redux';
import logo from '../assets/imgs/DigitalContacts-logo.svg';
import { resetPassword } from '../actions/resetPassword';
import { recallResetLink } from '../utils/resetLinkSession';

const ResetPassword = ({
  resetPassword,
  emailFound,
  error,
  codeMatched,
  user,
  code,
}) => {
  const [password, setpassword] = useState({
    Pass: '',
    rePass: '',
  });

  // Same reload hazard EnterCode documents: the service worker can reload
  // the page out from under a cold arrival, wiping Redux. Without this
  // fallback the customer would get through the code step and then be
  // bounced from here to /login -- with the guard's "Password Reset
  // Successful" alert, having reset nothing.
  //
  // `verified` is only true once /code_check accepted the code in this
  // tab, so this recovers an interrupted flow rather than opening the
  // screen to anyone who types the URL. The server re-checks the code on
  // submit regardless; this guard is about not stranding people.
  const remembered = recallResetLink();
  const emailForSubmit = user || remembered.email;
  const codeForSubmit = code || remembered.code;
  const codeIsVerified = codeMatched || remembered.verified;

  // No isAuth gate -- see Reset.js. Removing it here matters as much as
  // in the two screens before: leaving it would let a signed-in customer
  // through the request and code screens only to be bounced at the last
  // one, after their code had already been checked, with no way to
  // finish.
  //
  // The two remaining conditions are flow integrity -- this screen has
  // nothing to submit without an address and a verified code. It is also
  // how a completed reset ends: PASS_RESET_COMPLETE clears both flags,
  // which lands here and sends the customer to the login screen.
  if (!(emailFound || remembered.email) || !codeIsVerified) {
    alert(
      'Password reset successful. Sign in with your new password. ' +
        "You've been signed out on your other devices."
    );
    return <Redirect to='/login' />;
  }

  if (error) {
    alert(error);
  }

  return (
    <div class='my-name create-account wel-back'>
      <div className='container'>
        <div className='row'>
          <div className='col-12'>
            <div className='login1'>
              <Link to='login' className='account1'>
               Got your card?
              </Link>
              <Link to='login' className='log-in'>
                login
              </Link>
            </div>
            <div className='logo'>
              <Link to='/'>
                <img src={logo} alt='logo' />
              </Link>
            </div>
            <form
              id='resetPass'
              onSubmit={(e) => {
                e.preventDefault();
                if (password.Pass !== password.rePass) {
                  alert("Password doesn't match");
                }
                resetPassword(password.Pass, emailForSubmit, codeForSubmit);
              }}
            >
              <h1>Reset Password</h1>
              <p className='p1'></p>
              <input
                type='password'
                name='password'
                id='Pass'
                placeholder='New Password'
                required
                minLength='6'
                value={password.Pass}
                onChange={(e) =>
                  setpassword({ ...password, [e.target.id]: e.target.value })
                }
                style={{ marginBottom: '15px' }}
              />
              <input
                type='password'
                id='rePass'
                placeholder='Retype Password'
                required
                minLength='6'
                value={password.rePass}
                onChange={(e) =>
                  setpassword({ ...password, [e.target.id]: e.target.value })
                }
                style={{ marginBottom: '15px' }}
              />
              {/* Said before the button, not only after it. Signing
                  someone out of their other devices is the intended
                  effect of a reset (see middleware/auth.js), but it is
                  indistinguishable from a fault if it is a surprise. */}
              <p style={{ fontSize: '12px', marginTop: '2px', marginBottom: '12px' }}>
                Setting a new password signs you out on your other devices.
                You'll need to sign in again there.
              </p>
              <button className='btn w-100prc' id='submitBtnResetPass'>
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  loading: state.registerUser.loading,
  emailFound: state.resetPassword.emailFound,
  error: state.resetPassword.error,
  codeMatched: state.resetPassword.codeMatched,
  user: state.resetPassword.user,
  code: state.resetPassword.code,
});

export default connect(mapStateToProps, { resetPassword })(ResetPassword);
